import { themedColor } from '@lemonade-hq/cdk';
import { rgba } from 'polished';
import { css } from 'styled-components';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    color: ",
        ";\n    g,\n    path {\n      stroke: ",
        ";\n    }\n    background-color: ",
        ";\n    border: 1px solid transparent;\n    transition: all 0.3s, transform 0.5s;\n\n    :hover {\n      background-color: ",
        ";\n    }\n\n    :active,\n    :focus-visible {\n      background-color: ",
        ";\n      transform: translateY(1px);\n    }\n\n    &[disabled] {\n      background-color: ",
        ";\n      box-shadow: none;\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    color: ",
        ";\n    g,\n    path {\n      stroke: ",
        ";\n    }\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    transition: all 0.3s;\n\n    &:hover {\n      color: ",
        ";\n      g,\n      path {\n        stroke: ",
        ";\n      }\n      background-color: ",
        ";\n      transition: all 0.3s ease-out;\n    }\n\n    &[disabled] {\n      background-color: ",
        ";\n      color: ",
        ";\n      g,\n      path {\n        stroke: ",
        ";\n      }\n      border: 1px solid ",
        ";\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n    color: ",
        ";\n    g,\n    path {\n      stroke: ",
        ";\n    }\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    transition: all 0.3s;\n\n    :hover {\n      background-color: ",
        ";\n    }\n\n    :active,\n    :focus-visible {\n      background-color: ",
        ";\n      transform: translateY(1px);\n    }\n\n    &[disabled] {\n      background-color: ",
        ";\n      color: ",
        ";\n      g,\n      path {\n        stroke: ",
        ";\n      }\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    color: ",
        ";\n    background-color: ",
        ";\n    border-radius: 100px;\n    transition: all 0.3s;\n    border: none;\n\n    g,\n    path {\n      stroke: ",
        ";\n    }\n\n    ",
        "\n\n    &[disabled] {\n      background-color: ",
        ";\n      color: ",
        ";\n      g,\n      path {\n        stroke: ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n    color: ",
        ";\n    g,\n    path {\n      stroke: ",
        ";\n    }\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    transition: all 0.3s;\n\n    :hover {\n      background-color: ",
        ";\n    }\n\n    @media (hover: none) {\n      :hover {\n        background-color: transparent;\n      }\n      :active {\n        background-color: ",
        ";\n      }\n    }\n\n    &[disabled] {\n      background-color: ",
        ";\n      color: ",
        ";\n      border: 1px solid ",
        ";\n      g,\n      path {\n        stroke: ",
        ";\n      }\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n    color: ",
        ";\n    g,\n    path {\n      stroke: ",
        ";\n    }\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    transition: all 0.3s ease;\n\n    :hover {\n      background-color: ",
        ";\n    }\n\n    :active,\n    :focus-visible {\n      background-color: ",
        ";\n      transform: translateY(1px);\n    }\n\n    &[disabled] {\n      background-color: ",
        ";\n      color: ",
        ";\n      g,\n      path {\n        stroke: ",
        ";\n      }\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var FLAVOR_STYLES = {
    primary: css(_templateObject(), themedColor("white"), themedColor("white"), themedColor("primary"), themedColor("darkPrimary"), themedColor("darkerPrimary"), themedColor("mercury"), function(param) {
        var _param_glowing = param.glowing, glowing = _param_glowing === void 0 ? false : _param_glowing, theme = param.theme;
        return glowing && "box-shadow: 0px 10px 40px -10px ".concat(rgba(theme.colors.primary, 0.5), ";");
    }),
    ghost: css(_templateObject1(), themedColor("primary"), themedColor("primary"), themedColor("white"), themedColor("primary"), themedColor("white"), themedColor("white"), themedColor("primary"), themedColor("mercury"), themedColor("white"), themedColor("metal"), themedColor("light"), function(param) {
        var _param_glowing = param.glowing, glowing = _param_glowing === void 0 ? false : _param_glowing, theme = param.theme;
        return glowing && "box-shadow: 0px 10px 40px -10px ".concat(rgba(theme.colors.primary, 0.5), ";");
    }),
    standard: css(_templateObject2(), themedColor("night"), themedColor("night"), themedColor("cloud"), themedColor("light"), themedColor("glass"), themedColor("gainsboro"), themedColor("cloud"), themedColor("metal"), themedColor("metal"), function(param) {
        var _param_glowing = param.glowing, glowing = _param_glowing === void 0 ? false : _param_glowing, theme = param.theme;
        return glowing && "box-shadow: 0px 10px 40px -10px ".concat(rgba(theme.colors.night, 0.5), ";");
    }),
    dark: css(_templateObject3(), themedColor("white"), themedColor("black"), themedColor("white"), function(param) {
        var _param_glowing = param.glowing, glowing = _param_glowing === void 0 ? false : _param_glowing, theme = param.theme;
        return glowing && "box-shadow: 0px 10px 40px -10px ".concat(rgba(theme.colors.black, 0.5), ";");
    }, themedColor("cloud"), themedColor("metal"), themedColor("metal")),
    simple: css(_templateObject4(), themedColor("night"), themedColor("night"), themedColor("white"), themedColor("night"), themedColor("glass"), themedColor("glass"), themedColor("white"), themedColor("glass"), themedColor("glass"), themedColor("glass"), function(param) {
        var _param_glowing = param.glowing, glowing = _param_glowing === void 0 ? false : _param_glowing, theme = param.theme;
        return glowing && "box-shadow: 0px 10px 40px -10px ".concat(rgba(theme.colors.night, 0.5), ";");
    }),
    bright: css(_templateObject5(), themedColor("night"), themedColor("night"), themedColor("white"), themedColor("light"), themedColor("cloud"), themedColor("glass"), themedColor("cloud"), themedColor("metal"), themedColor("metal"), function(param) {
        var _param_glowing = param.glowing, glowing = _param_glowing === void 0 ? false : _param_glowing, theme = param.theme;
        return glowing && "box-shadow: 0px 10px 40px -10px ".concat(rgba(theme.colors.night, 0.5), ";");
    })
};

export { FLAVOR_STYLES };
